













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListHaisoArea',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'haisoAreaCd',
        width: 70,
      },
      {
        text: '配送エリア名',
        sortable: true,
        value: 'haisoAreaMei',
        width: 170,
      },
      {
        text: 'コメント',
        sortable: true,
        value: 'haisoAreaComment',
        width: 340,
      },
    ],
    formatColName: 'haisoAreaCd',
  }),
});
